import { render } from "./pop-up-change-phone.vue?vue&type=template&id=2daeb0c0&scoped=true"
import script from "./pop-up-change-phone.vue?vue&type=script&lang=js"
export * from "./pop-up-change-phone.vue?vue&type=script&lang=js"

import "./pop-up-change-phone.vue?vue&type=style&index=0&id=2daeb0c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2daeb0c0"]])

export default __exports__